<template>
  <div
    class="operation-report-show-body-task-progress"
  >
    <operation-report-workflow-status
      v-for="wsFD in workflowStatuesForDisplay"
      :key="wsFD.id"
      v-bind="wsFD"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("operationReport");

import OperationReportWorkflowStatus from "./WorkflowStatus";

export default {
  name: "OperationReportShowBodyTaskProgress",
  components: { OperationReportWorkflowStatus },

  computed: {
    ...mapGetters({
      reportWorkflowStatuses: "reportWorkflowStatuses",
      currentWorkflowStatus: "reportWorkflowStatus",
    }),

    // 進捗情報表示用に整形
    workflowStatuesForDisplay() {
      const cws = this.currentWorkflowStatus;
      return this.reportWorkflowStatuses
        .filter(ws => ws)
        .filter(ws => 0 <= ws.sort_order) // sort_orderが0以上を並べる
        .filter(ws => !ws.is_complete) // 完了は表示しない => is_complete: trueは表示しない
        .map((ws, index) => {
          const no = (ws.sort_order || 0) + 1;
          const isFirst = index === 0;
          return {
            id: ws.id, // keyにする
            noLabel: `${no}`.padStart(2, "0"), // 01, 02, 03, ... と表示する
            headerLabel: ws.short_label,
            footerLabel: `（${ws.supplement_label}）`,
            isDone: ws.sort_order < cws.sort_order, // 対応済みのステータス
            isDoing: ws === cws, // 現在対応中のステータス
            isTodo: cws.sort_order < ws.sort_order, // 今後対応予定のステータス
            showProgressBar: !isFirst,
          };
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body-task-progress {
  display: grid;
  grid-template-rows: auto auto auto auto; // 番号・ヘッダー・丸・フッターの4行
  grid-auto-flow: column;
  grid-auto-columns: 120px;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
